import React from "react";
import { getAllVendors, VendorResponse } from "../../services/vendorService";

type AccountOption = { value: string; label: string };

export const useVendorAccounts = (searchText: string) => {
    const [vendors, setVendors] = React.useState<VendorResponse[]>([]);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState<string | null>(null);

    React.useEffect(() => {
        let mounted = true;
        const load = async () => {
            try {
                setLoading(true);
                const data = await getAllVendors();
                if (!mounted) return;
                setVendors(data);
            } catch (err: any) {
                if (!mounted) return;
                setError(err?.message || "Failed to load vendors");
            } finally {
                if (!mounted) return;
                setLoading(false);
            }
        };

        load();
        return () => {
            mounted = false;
        };
    }, []);

    const filteredVendors = React.useMemo(() => {
        const query = searchText.trim().toLowerCase();
        return vendors
            .filter((v) => Boolean(v.ven_active))
            .filter((v) => `${v.ven_code ?? ""} ${v.ven_Name ?? ""}`.toLowerCase().includes(query));
    }, [vendors, searchText]);

    const accountOptions: AccountOption[] = React.useMemo(() => {
        return filteredVendors.map((vendor) => ({
            value: vendor.ven_code ?? "",
            label: `${vendor.ven_code ? `${vendor.ven_code} - ` : ""}${vendor.ven_Name ?? "Unnamed vendor"}`,
        }));
    }, [filteredVendors]);

    return {
        loading,
        error,
        vendors,
        filteredVendors,
        accountOptions,
        panelTitle: "Supplier Payments",
        searchLabel: "Search vendor",
        fieldPlaceholder: "Search active vendor code or name",
        fieldListId: "vendor-account-options",
        drawerTitle: "Search Vendors",
        drawerPlaceholder: "Search vendor by code or name",
    };
};
